var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('polygon',{attrs:{"points":"20.59 8.1 2.05 8.16 2.07 5.73 21.95 5.73"}}),_c('polygon',{attrs:{"points":"18.14 13.16 4.51 13.22 4.53 10.79 19.49 10.79"}}),_c('polygon',{attrs:{"points":"15.12 18.22 7.52 18.28 7.54 15.84 16.48 15.84"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }